import React from 'react';
import styled from 'styled-components';

import Wrapper from '../elements/wrapper';
import { media } from '../helpers';

import Wave from '../../images/waves/home-top-wave.inline.svg';

const ProductWaveContainer = styled.div`
    background-color: #f2f0eb;
    .svg-container {
        background-color: #f2f0eb;

        svg {
            width: 100%;
            height: auto;

            path {
                mask: none;
                opacity: 1;
                fill: #fff;
            }
        }
    }
    .title-container {
        max-width: 650px;
        text-align: center;
        padding-bottom: 20vh;
        h3 {
            font-size: 2.2rem;
            margin: 0 0 20px;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            color: #000;
            ${media.large`font-size: 2.6rem;`}
        }

        p {
            font-size: 0.9rem;
        }
    }
`;

// this is for colormatch chart product
const ProductWave = ({ pdp_acf }) => {
    const { productDescriptionTitle, productDescription } = pdp_acf || {};

    function createContent() {
        return { __html: productDescription };
    }

    return (
        <ProductWaveContainer>
            <div className="svg-container">
                <Wave />
            </div>

            <Wrapper className="content-container">
                <Wrapper className="title-container">
                    <h3>{productDescriptionTitle}</h3>
                    <div
                        className="content"
                        dangerouslySetInnerHTML={createContent()}
                    ></div>
                </Wrapper>
            </Wrapper>
        </ProductWaveContainer>
    );
};

export default ProductWave;
